module.exports = __webpack_public_path__ + "img/illustration_fran.f3ee4608.png";